export const AUDIO_LEVEL_THRESHOLD = 10;
export const MIN_TALKING_DURATION = 300;
export const MIN_SILENCE_DURATION = 1000;

export const AUDIO_SAMPLE_INTERVAL = 200;

export const SAMPLE_WINDOW = 10;
